function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.316 5.816a.8.8 0 00-1.132-1.132L12 10.87 5.816 4.684a.8.8 0 10-1.132 1.132L10.87 12l-6.185 6.184a.8.8 0 001.132 1.132L12 13.13l6.184 6.185a.8.8 0 001.132-1.132L13.13 12z",
    fill: props.fill
  }));
}

export default SvgX;